/*  MUI  */
import { Box } from '@mui/material';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

/*  Components  */
import CoverPage from '../Components/Containers/CoverPage';

/*  Reports  */
import Overview from './Reports/Overview';

/*  State  */
const state = () => ({
    loaded: false
});

class OffboardReport extends Component {
    constructor(props) {
        super(props);
        this.state = state();
    }

    componentDidMount() {
        this.load();
    }

    load = () => {
        const { reportData } = this.props;

        if (!reportData) {
            return;
        }

        this.setState({ loaded: true });
    };

    render() {
        const { reportData, reportSetup, renderingScheduledReport } =
            this.props;
        const {
            reportSelections: { offboardUserOffboardCover }
        } = reportSetup;
        const { loaded } = this.state;

        if (!loaded) {
            return null;
        }

        const { offboardUserOffboardOverview } = reportData;
        if (!offboardUserOffboardOverview && offboardUserOffboardCover) {
            return <CoverPage reportSetup={reportSetup} />;
        }

        return (
            <Box data-trackid="offboardReportContainer" width="100%">
                {offboardUserOffboardCover && (
                    <CoverPage reportSetup={reportSetup} />
                )}
                <Box m="32px" data-trackid="offboardReportOverviewWrapper">
                    <Overview
                        renderingScheduledReport={renderingScheduledReport}
                        reportSetup={reportSetup}
                        reportData={offboardUserOffboardOverview}
                    />
                </Box>
            </Box>
        );
    }
}

export default withTranslation()(OffboardReport);
